import React from 'react'
import './Stories.css'

function Stories() {
  return (
    <div className='story'>
        <div className='stories'>
            <h3>STORIES</h3>
            <p>Testimonials are being collected to document the health conditions of residents living near energy facilities. In the meantime, you can 
              view the articles provided below.
            </p>
        </div>

        <div className='articles'>
            <h3>ARTICLES</h3>
            <a href='https://www.houstonchronicle.com/author/rebekah-ward/' target="_blank">Houston Chronicle's Coverage on environment and energy</a>
            <br />
            <a href='https://www.axios.com/2023/05/10/oil-gas-health-impacts-study' target="_blank">Oil and gas health impacts cost $77 billion per year, study finds</a>
            <br />
            <a href='https://www.hrw.org/news/2024/01/25/us-louisianas-cancer-alley' target="_blank">US: Louisiana’s ‘Cancer Alley’</a>
            <br />
            <a href='https://www.nytimes.com/2024/04/09/climate/epa-pollution-chemical-plants.html' target="_blank">To Cut Cancer Risks, E.P.A. Limits Pollution From Chemical Plants</a>
            <br />
            <a href='https://www.bloomberg.com/news/articles/2024-02-06/court-decision-blocks-epa-action-in-louisiana-s-cancer-alley' target="_blank">Court Ruling Could Set Back ‘Decades of Work’ in Polluted Black Communities</a>
            <br />
            <a href='https://apnews.com/article/chevron-union-oil-kevin-wright-california-santa-barbara-benzene-myeloma-cancer-63-million-57529d07bb50b8882f719d1e8707d951' target="_blank">Jury returns $63M verdict after finding Chevron covered up toxic pit on California land</a>
            <br />
            <a href='https://www.bbc.com/news/stories-53640382' target="_blank">How the oil industry made us doubt climate change</a>
            <br />
            <a href='https://www.theguardian.com/environment/2022/may/12/us-oil-refineries-benzene-pollution-cancer-causing' target="_blank">US oil refineries spewing cancer-causing benzene into communities, report finds</a>
            <br />
            <a href='https://www.texastribune.org/2022/05/12/texas-refineries-benzene/' target="_blank">Five Texas refineries polluted above federal limit on cancer-causing benzene last year, report found</a>
            <br />
            <a href='https://gizmodo.com/offset-carbon-credits-industrial-sabotage-1850114026' target="_blank">Eco-Crime Pays: New Scheme Lets You Trade ‘Industrial Sabotage’ for Carbon Credits</a>
            <br />
            <a href='https://www.vice.com/en/article/88np3v/what-is-carbon-footprint-net-zero-greenwashing-emissions-guide' target="_blank">'Carbon Footprint' and 'Net Zero' Don't Mean What You Think</a>
            <br />
            <a href='https://www.hrw.org/report/2024/01/25/were-dying-here/fight-life-louisiana-fossil-fuel-sacrifice-zone' target="_blank">The Fight for Life in a Louisiana Fossil Fuel Sacrifice Zone </a>
            <br />
            <a href='https://ehsdailyadvisor.blr.com/2024/01/continued-rise-in-pfas-litigation-expected-in-2024/' target="_blank">Continued Rise in PFAS Litigation Expected in 2024</a>
            <br />
            <a href='https://apnews.com/article/epa-louisiana-cancer-alley-pollution-discrimination-915d957401318aaf57fc478afbf29f9a' target="_blank">Louisiana was open to Cancer Alley concessions. Then EPA dropped its investigation</a>
            <br />
            <a href='https://insideclimatenews.org/news/31102023/oil-gas-companies-spill-wastewater-in-texas/' target="_blank">Oil and Gas Companies Spill Millions of Gallons of Wastewater in Texas</a>
            <br />
            <a href='https://capitalbnews.org/gas-exports-black-activism/' target="_blank">The Black-Led Movement to Stop ‘New Cancer Alleys’ From Being Built in Louisiana</a>
            <br />
            <a href='https://www.commondreams.org/news/big-oil-sacrifice-zones' target="_blank">'Death Sentence': Reports Call for End to Big Oil's US Sacrifice Zones </a>
            <br />
            <a href='https://www.sciencedirect.com/science/article/pii/S0048969716322392' target="_blank">Unconventional oil and gas development and risk of childhood leukemia: Assessing the evidence</a>
            <br />
            <a href='https://www.theatlantic.com/science/archive/2024/01/biden-liquid-natural-gas-pause-climate-voters/677259/' target="_blank">Why Biden Handed Climate Activists a Huge Victory</a>
            <br />
            <a href='https://www.washingtonpost.com/climate-environment/2023/10/17/natural-gas-exports-climate-activists/' target="_blank">The next front in the climate fight: U.S. exports of natural gas</a>
            <br />
            <a href='https://www.nytimes.com/2024/01/25/climate/a-huge-win-for-activists-puts-climate-on-the-2024-agenda.html' target="_blank">A Huge Win for Activists Puts Climate on the 2024 Agenda</a>
            <br />
            <a href='https://www.vox.com/climate/2023/9/21/23879312/climate-protests-activism-un-climate-week' target="_blank">What climate activists mean when they say “end fossil fuels”</a>
            <br />
        </div>

        <div className='datasets'> 
          <h3>DATASETS</h3>
          <a href='https://peri.umass.edu/greenhouse-100-polluters-index-current' target="_blank">PERI’S Greenhouse 100 Polluters Index</a>
          <br />
          <a href='https://www.grconnect.com/tox100wt/ry2021/index.php' target="_blank">PERI’S Toxic 100 Water Polluters Detailed Company Reports</a>
        </div>

    </div>
  )
}

export default Stories